var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSliderDragButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#9D004C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.75 30.3a.84.84 0 0 1-1.22 0l-5.18-5.39a.92.92 0 0 1 0-1.27l5.18-5.38a.84.84 0 0 1 1.22 0c.33.35.33.92 0 1.27l-3.7 3.87-.95.88s.5.46.94.9l3.7 3.85c.34.35.34.92 0 1.27Zm12.5-12.04a.84.84 0 0 1 1.22 0l5.18 5.38c.34.35.34.92 0 1.27l-5.18 5.39a.84.84 0 0 1-1.22 0 .92.92 0 0 1 0-1.27l3.7-3.87.95-.88s-.5-.46-.94-.9l-3.7-3.85a.92.92 0 0 1 0-1.27Z",
  fill: "#fff"
})));
export default SvgSliderDragButton;